import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import {
  type ApiError,
  type ApiResponse,
  addActionNameToMutationResult,
  useAxiosInstance,
} from 'shared/hooks/utils';
import { EMAIL_DOMAIN_QUERY_KEY, EMAIL_DOMAIN_URL } from './use-load-email-domain';

export async function deleteEmailDomainFn(axiosInstance: Promise<AxiosInstance>) {
  const instance = await axiosInstance;

  return instance.delete(EMAIL_DOMAIN_URL);
}

export function useDeleteEmailDomain() {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, void>({
    mutationFn: () => deleteEmailDomainFn(axiosInstance),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: EMAIL_DOMAIN_QUERY_KEY });
      // Deleting the domain also clears the sender stored on the company and on
      // every template, so both aggregates have to be refetched.
      client.invalidateQueries({ queryKey: ['emailSendingPreferences'] });
      client.invalidateQueries({ queryKey: ['companyConfigurationV2'] });
    },
  });

  return addActionNameToMutationResult<ApiResponse, ApiError, void, 'deleteEmailDomain'>(
    'deleteEmailDomain',
    mutation,
  );
}
